import AnalyzeService from '../../services/analyze';

// actions
export const FETCH_SURVEYS_BY_TENANT = 'FETCH_SURVEY_BY_TENANT';

/**
 * action: fetch surveys by tenant
 *
 * @param {*} id
 * @param {*} dispatch
 */
export function fetchSurveysByTenant(id, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.fetchSurveysByTenant(id);
  dispatch({ type: FETCH_SURVEYS_BY_TENANT, payload: dataPromise });
}
